/*
 * @Author: LUOHM
 * @Date: 2021-04-21 10:50:20
 * @LastEditTime: 2022-05-11 11:16:53
 * @LastEditors: LUOHM
 */
const PREFIX = 'c360'
const NUM_OF_QUESTION = 4

//根据key获取本地存储数据
const getStorage = (key) => {
  const s = localStorage.getItem(`${PREFIX}_${key}`);
  let tmpArr
  if (s && s.includes("|||")) {
    tmpArr = _parseString(s);
    return tmpArr
  }
  return s;
}

//保存数据到本都存储
const setStorage = (key, value) => {
  if (Array.isArray(value)) {
    value = value.join('|||')
  }
  localStorage.setItem(`${PREFIX}_${key}`, value);
}

const _parseString = (s) => {
  let arr = s.split('|||')
  let list = []
  arr.forEach((item, index) => {
    if (item) {
      if (index < NUM_OF_QUESTION - 1) {
        list[index] = item.split(',').map(v => v === 'true')
      } else {
        list[index] = item
      }
    }
  })
  return list
}

const getQueryVariable = (name) => {
  let search = window.location.search.substr(1) || window.location.hash.split("?")[1];
  let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
  let r = search.match(reg);
  if (r != null) return  unescape(r[2]); return null;
}

export default {
  getStorage,
  setStorage,
  getQueryVariable
}
